import {
  ApiKey,
  darkThemeStyles,
  DATE_TIME_EXTENDED_FORMAT,
  format,
  JupiterTheme,
  parseISO,
} from '@jupiterone/jupiter-web-toolkit';
import {
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import DeleteIcon from 'react-feather/dist/icons/x';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    ...darkThemeStyles,
    row: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      '&:hover': {
        background: 'none',
      },
    },
    iconButton: {
      color: theme.palette.navy[300],
      '&:hover svg': {
        color: theme.palette.red[500],
      },
      padding: 0,
      marginRight: -theme.spacing(2),
    },
    dateCell: {
      width: 40,
    },
    deleteCell: {
      width: 20,
    },
  })
);

interface Props {
  apiKey: ApiKey;
  onDeleteClick: () => void;
}

const ApiKeyRow = ({ apiKey, onDeleteClick }: Props) => {
  const classes = useStyles();

  const name = apiKey.name;
  const key = apiKey.key;

  const createdAt = format(
    parseISO(apiKey.dateCreated),
    DATE_TIME_EXTENDED_FORMAT
  );
  const expiresAt = format(
    parseISO(apiKey.dateExpires),
    DATE_TIME_EXTENDED_FORMAT
  );

  return (
    <>
      <TableRow className={classes.row}>
        <TableCell component="td" scope="row" className={classes.bodyCell}>
          <Typography variant="caption" className={classes.cellText}>
            {name}
          </Typography>
        </TableCell>
        <TableCell component="td" scope="row" className={classes.bodyCell}>
          <Typography variant="caption" className={classes.cellText}>
            {key}
          </Typography>
        </TableCell>
        <TableCell
          component="td"
          scope="row"
          className={clsx(classes.bodyCell, classes.dateCell)}
        >
          <Typography variant="caption" className={classes.cellText}>
            {createdAt}
          </Typography>
        </TableCell>
        <TableCell
          component="td"
          scope="row"
          className={clsx(classes.bodyCell, classes.dateCell)}
        >
          <Typography variant="caption" className={classes.cellText}>
            {expiresAt}
          </Typography>
        </TableCell>
        <TableCell
          component="td"
          scope="row"
          className={clsx(classes.bodyCell, classes.deleteCell)}
        >
          <Tooltip title="Delete" enterDelay={500} placement="right">
            <IconButton className={classes.iconButton} onClick={onDeleteClick}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    </>
  );
};

export default ApiKeyRow;
